<style>
    /*.dropdown-menu inner show*/
    .cust-margin ul.dropdown-menu.inner{
        margin-bottom :0px !important;
    }
</style>
<template>
    <div>
        <template v-if="custom_reporting == true && companies != null">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left">Edit Custom Report</h1>
            </div>
            <div class="global-main">
                <div class="people-management-inner-content">
                    <form @submit.prevent="editCustomReport()">
                        <input v-model="form.userID" type="hidden" name="userID" class="form-control" :class="{ 'is-invalid': form.errors.has('userID') }">
                        <div class="tab-content-inner">
                                <div class="user-permissions">
                                <div class="form-group">
                                    <label> Parent Company </label>
                                    <select v-model="form.parent_company_id" data-live-search="true" name="parent_company_id" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('parent_company_id') }" v-if="companies != null">
                                        <option value="" selected>Select Company</option>
                                        <option v-for="company in companies" v-bind:value="company.id" v-bind:key="company.id">
                                            {{ company.name }}
                                        </option>
                                    </select>
                                    <has-error :form="form" field="parent_company_id"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> Reporting Company </label>
                                    <select v-model="form.reporting_company_id" data-live-search="true" name="reporting_company_id" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('reporting_company_id') }" v-if="companies != null" v-on:change="getUserAgainstCompany($event)">
                                        <option value="" selected>Select Company</option>
                                        <option v-for="company in companies" v-bind:value="company.id" v-bind:key="company.id">
                                            {{ company.name }}
                                        </option>
                                    </select>
                                    <has-error :form="form" field="reporting_company_id"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> User </label>
                                    <select v-model="form.user" data-live-search="true" name="user" class="form-control selectpicker custom-select2 cust-margin" :class="{ 'is-invalid': form.errors.has('user') }" v-if="users != null">
                                        <option value="" selected>Select User</option>
                                        <option v-for="user in users" v-bind:value="user.id" v-bind:key="user.id">
                                            {{ user.name }}
                                        </option>
                                    </select>
                                    <has-error :form="form" field="user"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> Bifurcation </label>
                                    <input v-model="form.bifurcation" type="text" name="bifurcation" class="form-control" :class="{ 'is-invalid': form.errors.has('bifurcation') }">
                                    <has-error :form="form" field="bifurcation"></has-error>
                                </div>
                                <div class="page-top mb-1 mb-3 clearfix">
                                    <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                                    <router-link to="/adminCustomReports" class="btn btn-primary float-right mr-1"> Cancel </router-link>
                                </div>
                            </div>

                        </div>

                    </form>
                </div>
            </div>
        </template>
        <template v-else-if="custom_reporting === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="custom_reporting === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    parent_company_id : '',
                    user : '',
                    reporting_company_id : '',
                    bifurcation : '',
                    userID : '',
                }),
                companies: null,
                users: [],
                custom_reporting: null
            }
        },
        methods: {
            editCustomReport() {
                this.$Progress.start();
                this.form.put('/api/updateCustomReport')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                        this.showToastBox('success','Custom report updated successfully');
                        this.$router.push('/adminCustomReports');
                    }else{
                        this.$Progress.fail();
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                        this.showAlertBox('error','Some problem in your form data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    this.showAlertBox('error','Some problem in your form data');
                });
            },
            getUserAgainstCompany(event) {
                this.$Progress.start();
                axios.get('/api/getUserAgainstCompany/'+event.target.value)
                .then(res => {
                    if(res.status == 200){
                        this.form.user = '';
                        this.users = [];
                        this.users = res.data.users;
                        this.pageView = res.data.pageView;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }
                }).then(res => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    this.showAlertBox('error','Some error in your form data');
                });
            },
            getEditCustomReportData(){
                axios.get('/api/editCustomReport/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        this.form.id = res.data.id;
                        this.form.parent_company_id = res.data.parent_company;
                        this.form.reporting_company_id = res.data.reporting_company;
                        this.form.user = res.data.user_id;
                        this.form.bifurcation = res.data.bifurcation;
                        this.form.userID = res.data.userID;
                        this.companies = res.data.companyData;
                        this.users = res.data.userData;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    }
                }).then(res => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load form data');
                });
            }
        },
        updated(){
        },
        mounted() {
            this.$Progress.start();
            this.can('custom_reporting').then(result => {
                this.custom_reporting = result.custom_reporting;
            }).then(result => {
                if(this.custom_reporting == true){
					this.getEditCustomReportData();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        }
    }
</script>
